'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FileUploadErrorType from 'FileManagerCore/enums/FileUploadErrorType';
import FileIsNotAnImageError from './FileIsNotAnImageError';
import FileExtensionIsNotSupportedError from './FileExtensionIsNotSupportedError';
import DropZoneErrorTypes from '../../enums/DropZoneErrorTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const FileDropZoneUploadError = props => {
  const {
      type
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  switch (type) {
    case DropZoneErrorTypes.NOT_AN_IMAGE:
      return /*#__PURE__*/_jsx(FileIsNotAnImageError, Object.assign({}, rest));
    case DropZoneErrorTypes.INVALID_FILE_EXTENSION:
      return /*#__PURE__*/_jsx(FileExtensionIsNotSupportedError, Object.assign({}, rest));
    case DropZoneErrorTypes.PORTAL_SUSPENDED:
    case FileUploadErrorType.HIGH_RISK_PORTAL:
      return /*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerLib.suspension.disabledError"
        })
      });
    case DropZoneErrorTypes.USER_WRITE_PERMISSION:
    case FileUploadErrorType.MISSING_WRITE_SCOPE:
      return /*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerLib.permissions.disabledError"
        })
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerLib.fileUploadError"
      });
  }
};
export default FileDropZoneUploadError;